import { createContext } from "react";

// True for anything rendered inside a CustomTabsTable, so row action buttons
// can render compactly (icon + tooltip) without every table configuring it.
export const InTableContext = createContext(false);
